<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado mb-4">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">{{ $t('panelCliente.serviciosActivosTitulo') }}</h6>
              <p class="text-xs opacity-7 mb-0">Total: <b>{{ servicios.length }}</b></p>
            </div>
          </div>

          <div v-if="servicios.length === 0" class="alert alert-secondary text-sm mb-0">
            {{ $t('panelCliente.serviciosActivosVacio') }}
          </div>

          <div v-else class="table-responsive">
            <table class="table table-flush table-listado table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th>{{ $t('panelCliente.producto') }}</th>
                  <th>{{ $t('panelCliente.canal') }}</th>
                  <th>{{ $t('panelCliente.tipster') }}</th>
                  <th>{{ $t('panelCliente.referencia') }}</th>
                  <th>{{ $t('panelCliente.fechaCompra') }}</th>
                  <th class="text-center">{{ $t('panelCliente.acceso') }}</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="s in paginados" :key="s.pedido_id">
                  <td><div class="campana-nombre">{{ s.producto?.nombre || "-" }}</div></td>
                  <td>{{ s.canal?.nombre || "-" }}</td>
                  <td>{{ s.tipster?.nombre || "-" }}</td>
                  <td>{{ s.referencia || "-" }}</td>
                  <td>{{ fmtFechaHora(s.fecha_compra) }}</td>
                  <td class="td-acceso">
                    <div class="estado-acceso-cell">
                      <div class="estado-acceso-group">
                        <span
                          class="badge badge-acceso text-uppercase"
                          :class="s.estado_acceso === 'pendiente' ? 'badge-warn' : 'badge-ok'"
                        >{{ s.estado_acceso || "-" }}</span>
                        <template v-if="s.estado_acceso === 'pendiente'">
                          <button class="btn btn-ver-enlace" type="button" title="Ver enlace" @click="mostrarEnlace(s)">👁</button>
                          <button class="btn btn-abrir-enlace" type="button" title="Abrir enlace" @click="abrirEnlace(s)">↗</button>
                        </template>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="paginacion-panel-cliente">
              <div class="paginacion-info text-xs opacity-7">
                {{ $t('panelCliente.serviciosPagInfo', { desde, hasta, total: servicios.length }) }}
              </div>
              <div class="paginacion-botones">
                <button type="button" class="btn btn-paginacion" :disabled="page === 1" @click="page = 1">&lt;&lt;</button>
                <button type="button" class="btn btn-paginacion" :disabled="page === 1" @click="page--">&lt;</button>
                <span class="pagina-actual">{{ $t('panelCliente.paginaDeTotal', { page, total: totalPages }) }}</span>
                <button type="button" class="btn btn-paginacion" :disabled="page === totalPages" @click="page++">&gt;</button>
                <button type="button" class="btn btn-paginacion" :disabled="page === totalPages" @click="page = totalPages">&gt;&gt;</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";

export default {
  name: "PanelClienteServiciosActivos",
  props: {
    servicios: { type: Array, default: () => [] },
  },
  data() {
    return { page: 1, perPage: 5 };
  },
  watch: {
    servicios() { this.page = 1; },
  },
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.servicios.length / this.perPage)); },
    paginados() {
      const start = (this.page - 1) * this.perPage;
      return this.servicios.slice(start, start + this.perPage);
    },
    desde() { return this.servicios.length === 0 ? 0 : (this.page - 1) * this.perPage + 1; },
    hasta() { return Math.min(this.page * this.perPage, this.servicios.length); },
  },
  methods: {
    mostrarEnlace(servicio) {
      const enlace = servicio?.invite_link || "";
      if (!enlace) {
        showSwal.methods.showSwal({ type: "warning", message: this.$t('panelCliente.sinEnlace'), width: 520 });
        return;
      }
      showSwal.methods.showSwal({
        type: "info",
        title: this.$t('panelCliente.enlaceDeUnion'),
        message: this.$t('panelCliente.enlaceMsg', { nombre: servicio?.producto?.nombre || '-', enlace }),
        width: 700,
        confirmButtonText: this.$t('panelCliente.cerrar'),
      });
    },
    abrirEnlace(servicio) {
      const enlace = servicio?.invite_link || "";
      if (!enlace) {
        showSwal.methods.showSwal({ type: "warning", message: this.$t('panelCliente.sinEnlace'), width: 520 });
        return;
      }
      window.open(enlace, "_blank", "noopener,noreferrer");
    },
    fmtFechaHora(fechaStr) {
      if (!fechaStr) return "-";
      try {
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        const locale = this.$i18n?.locale === 'en' ? 'en-GB' : 'es-ES';
        return d.toLocaleString(locale);
      } catch { return fechaStr; }
    },
  },
};
</script>

<style scoped>
.campana-nombre { font-weight: 700; color: var(--q-text); line-height: 1.15; }

.td-acceso { width: 190px; min-width: 190px; white-space: nowrap; text-align: center; }
.table-empirulada tbody td.td-acceso { vertical-align: middle; }
.estado-acceso-cell { width: 100%; display: flex; align-items: center; justify-content: center; }
.estado-acceso-group { display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 34px; white-space: nowrap; }
.badge-acceso {
  display: inline-flex; align-items: center; justify-content: center;
  height: 26px; min-width: 98px; padding: 0 14px; line-height: 1;
  border-radius: 999px; font-size: 11px; font-weight: 700; vertical-align: middle; flex: 0 0 auto;
}
.badge-ok   { background: var(--q-green-soft); color: var(--q-green);  border: 1px solid var(--q-green); }
.badge-warn { background: var(--q-amber-soft); color: var(--q-amber);  border: 1px solid var(--q-amber); }
.btn-ver-enlace, .btn-abrir-enlace {
  display: inline-flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; padding: 0; border: 0; color: #fff;
  border-radius: 999px; font-weight: 700; line-height: 1;
  box-shadow: 0 4px 10px rgba(0,0,0,.12); flex: 0 0 30px; vertical-align: middle;
}
.btn-ver-enlace { background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover)); }
.btn-abrir-enlace { background: linear-gradient(90deg, var(--q-green), #26c6da); }
.btn-ver-enlace:hover, .btn-abrir-enlace:hover { transform: translateY(-1px); transition: .15s ease; }

.table-empirulada { border-collapse: separate !important; border-spacing: 0 10px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 12px 14px; }
.table-empirulada tbody tr { background: var(--q-card); box-shadow: 0 6px 18px rgba(0,0,0,.06); overflow: hidden; }
.table-empirulada tbody td { border: 0 !important; padding: 12px 14px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child {
  border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;
}
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.paginacion-panel-cliente { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; margin-top: 16px; padding-top: 10px; }
.paginacion-botones { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.btn-paginacion { min-width: 38px; height: 38px; padding: 0 10px; border: 0; border-radius: 10px; background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover)); color: #fff; font-weight: 700; box-shadow: 0 4px 10px rgba(0,0,0,.12); }
.btn-paginacion:disabled { opacity: .45; cursor: not-allowed; box-shadow: none; }
.pagina-actual { font-size: 13px; font-weight: 600; color: var(--q-text); }

@media (max-width: 768px) {
  .paginacion-panel-cliente { flex-direction: column; align-items: flex-start; }
}
</style>
